import { render, staticRenderFns } from "./CustomerImportUpload.vue?vue&type=template&id=2ca2148d&scoped=true"
import script from "./CustomerImportUpload.vue?vue&type=script&lang=js"
export * from "./CustomerImportUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca2148d",
  null
  
)

export default component.exports